<script>
  import { onMount } from "svelte";
  import * as d3 from "d3";
  import rewind from "@turf/rewind";


  import LanguageBarChart from "./components/language_barchart.svelte";
  import ArtistBubbleMap from "./components/artist_bubblemap.svelte";
  import KPIDashboard from "./components/kpi_dashboard.svelte";
  import YearLineGraph from "./components/release_year_linegraph.svelte";

  import languages from "./data/language_data.json";

  // Your bubble data
  import artist100 from "./data/spotify_data_visualization_artist_test.json";
</script>

<body>
  <div class="app-container">
    <section class="kpi-section">
      <KPIDashboard />
    </section>
    
    <section class="main-section">
      <div class="left-column">
        <LanguageBarChart data={languages} />
        <YearLineGraph />
        <!-- Genre word bubble-->
      </div>

      <div class="map-column">
        <ArtistBubbleMap data={artist100} />
      </div>
    </section>
  </div>
</body>

<style>
  /* 1. Use a more-intuitive box-sizing model */
  *, *::before, *::after {
    box-sizing: border-box;
  }
  /* 2. Remove default margin */
  *:not(dialog) {
    margin: 0;
  }
  /* 3. Enable keyword animations */
  @media (prefers-reduced-motion: no-preference) {
    html {
      interpolate-size: allow-keywords;
    }
  }
  body {
    /* 4. Add accessible line-height */
    line-height: 1.5;
    /* 5. Improve text rendering */
    -webkit-font-smoothing: antialiased;
  }
  /* 6. Improve media defaults */
  img, picture, video, canvas, svg {
    display: block;
    max-width: 100%;
  }
  /* 7. Inherit fonts for form controls */
  input, button, textarea, select {
    font: inherit;
  }
  /* 8. Avoid text overflows */
  p, h1, h2, h3, h4, h5, h6 {
    overflow-wrap: break-word;
  }
  /* 9. Improve line wrapping */
  p {
    text-wrap: pretty;
  }
  h1, h2, h3, h4, h5, h6 {
    text-wrap: balance;
  }

  /* 10. Create a root stacking context */
  #root, #__next {
    isolation: isolate;
  }

  :global(body) {
    margin: 0;
    padding: 0;
  }

  body { 
    background-color: #202020;
    }

  .app-container {
    display: grid;
    grid-template-rows: auto 1fr;
    height: 100vh;
    background: #0F0F0F;
    color: white;
    row-gap: 1.25rem;
  }

  .kpi-section {
    padding: 1.25rem 1.25rem 0;
    display: flex;
    align-items: center;
  }

  .main-section {
    display: grid;
    grid-template-columns: 1fr 2fr;
    padding-left: 1.25rem;
    padding-right: 1.25rem;
    padding-bottom: 1.25rem;
    gap: 0.25rem;
    min-height: 0;
  }

  .left-column {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    padding: 0;
    margin-right: 1rem;

    min-height: 0;
  }

  .map-column {
    background-color: #202020;
    border-radius: 16px;
    padding: 1.25rem;
    overflow: hidden;
    box-shadow: 0 0 8px rgba(29, 185, 84, 0.4);
    min-height: 0;
  }

  @media (max-width: 768px) {
    body {
      overflow-x: hidden;
    }

    .app-container {
      height: auto;
    }

    .main-section {
      display: flex;
      flex-direction: column-reverse;      
    }

    .left-column {
      margin-right: 0;
    }

    .map-column {
      margin-bottom: 1.25rem;
    }
  }

  @media (max-width: 480px) {
    body {
      overflow-x: hidden;
    }

    .app-container {
      height: auto;
    }

    .main-section {
      display: flex;
      flex-direction: column-reverse;      
    }

    .left-column {
      margin-right: 0;
    }

    .map-column {
      margin-bottom: 1.25rem;
    }
  }

</style>
